import { MInput, MRadio, MSelect, MTextArea } from '@Components/Base';

import { Col, Flex, Form, Row } from 'antd';

import { FormikProps } from 'formik';
import { Option } from '@Components/types/options';
import MUpload from '@Components/Base/Upload/Upload';

import { MaterialRequisitionDocumentRequest } from '@Types/api/form';
import { RcCustomRequestOptions } from '@Components/types/UploadType';
import { Attachment } from '@Components/types/Attachment';

import styles from './modal-content.module.css';
import { statusOptions, сonfidentialOptions } from './constants';

interface ModalContentProps {
  formik: FormikProps<MaterialRequisitionDocumentRequest>;
  documentTypes: Option[];
  uploadedFile?: Attachment;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
  onFileRequest: (options: RcCustomRequestOptions) => void;
  onFileRemove: () => void;
  onUploadedFileRemove?: (value: boolean | undefined) => void;
}

const ModalContent: React.FC<ModalContentProps> = ({
  formik,
  handleSubmit,
  documentTypes,
  onFileRemove,
  onFileRequest,
  uploadedFile,
  onUploadedFileRemove,
}) => {
  const statusValue = formik.values.deleteFlag;

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Row className={styles.container}>
        <Col span={24} className={styles.col}>
          <Form.Item label="Confidential">
            <Flex>
              {сonfidentialOptions.map((option) => (
                <MRadio
                  className={styles.radio}
                  key={option.label}
                  id={option.label}
                  value={option.value}
                  name="confidential"
                  labelText={option.label}
                  onChange={(event) =>
                    formik.setFieldValue('isConfidential', event.target.value)
                  }
                  checked={
                    Number(formik.values.isConfidential) ===
                    Number(option.value)
                  }
                />
              ))}
            </Flex>
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Type">
            <MSelect
              labeloption="Document Type"
              value={documentTypes[formik.values.procDocTypeId - 1]}
              options={documentTypes}
              onChange={(value) => {
                formik.setFieldValue('procDocTypeId', Number(value));
              }}
              placeholder="Select Document Type"
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Name">
            <MInput
              value={formik.values.docName}
              placeholder="Insert document name"
              onChange={(event) =>
                formik.setFieldValue('docName', event.target.value)
              }
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Description">
            <MTextArea
              name="docDesc"
              value={formik.values.docDesc}
              onChange={formik.handleChange}
              rows={4}
              showCount
              maxLength={100}
              placeholder="Description goes here"
            />
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Status">
            <Flex>
              {statusOptions.map((option) => {
                return (
                  <MRadio
                    className={styles.radio}
                    key={option.label}
                    id={option.label}
                    value={option.value}
                    name="status"
                    labelText={option.label}
                    onChange={(event) =>
                      formik.setFieldValue(
                        'deleteFlag',
                        Number(event.target.value)
                      )
                    }
                    checked={Number(statusValue) === Number(option.value)}
                  />
                );
              })}
            </Flex>
          </Form.Item>
        </Col>
        <Col span={24} className={styles.col}>
          <Form.Item label="Attachement">
            <MUpload
              onFileRequest={onFileRequest}
              onFileRemove={onFileRemove}
              uploadedFile={uploadedFile}
              onUploadedFileRemove={onUploadedFileRemove}
              showSwitcher={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ModalContent;
